import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table } from 'react-bootstrap'
import './PaymentPage.css'

export default class MarkPayment extends Component {
  static propTypes = {
    mark: PropTypes.object,
    onPayClick: PropTypes.func
  }

  render () {
    const { mark, onPayClick } = this.props
    return (<div className="col-md-offset-1 col-md-10">
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Riepilogo</h2>

          <div className="row">
            <div className="col-md-12 hidden-md hidden-lg">
              <div className="card-marks">
                <div className="capiton cart-caption">
                  <div className="col-md-4">
                    <h4>
                      <strong>Contrassegno: </strong>
                      <span className="text-left">
                        {mark.MarkType.name.toUpperCase() + ' ' + mark.Category.label.toUpperCase()}
                      </span>
                    </h4>
                    <h5>
                      <strong>Zon{mark.MarkType.Areas.length > 1 ? 'e' : 'a'}: </strong>
                      <span>{mark.MarkType.Areas.map(item => item.code + ' ')}</span>
                    </h5>

                    <h5>
                      <strong>Targ{mark.Vehicles.length > 0 ? 'he' : 'a'}: </strong>
                      <span>{mark.Vehicles.map(item => item.plate_number.toUpperCase() + ' ')}</span>
                    </h5>
                  </div>

                  <div className="col-md-4">
                    <h5>
                      <strong>Valido </strong>
                      <span className="text-left">
                        <strong>dal </strong> <span>{moment(mark.startDate).format('L')}</span>
                        <strong> al </strong> {moment(mark.endDate).format('L')}
                      </span>
                    </h5>
                  </div>

                  <div className="col-md-4">
                    <h4>
                      <strong>Prezzo </strong>
                      <span className="text-left">
                        € {Number(mark.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <Table responsive className="hidden-xs hidden-sm">
            <thead>
              <tr>
                <th>Prodotto</th>
                <th>Validità</th>
                <th>Targhe</th>
                <th>Zone</th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left">
                  <span>
                    {mark.MarkType.name.toUpperCase() + ' ' + mark.Category.label.toUpperCase()}
                  </span>
                </td>
                <td className="text-left">
                  {moment(mark.startDate).format('L') + ' - '}
                  {moment(mark.endDate).format('L')}
                </td>
                <td className="text-left">
                  {mark.Vehicles.map(item => item.plate_number.toUpperCase() + ' ')}
                </td>
                <td className="text-left">
                  {mark.MarkType.Areas.map(item => item.code + ' ')}
                </td>
                <td className="text-left">
                  € {Number(mark.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="row">
            <div className="text-center">
              <h3>Totale: € {Number(mark.price).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h3>
            </div>
          </div>

          <button onClick={() => onPayClick()} type="button" className="btn btn-green">
            Acquista
          </button>

        </div>
      </div>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/MarkPayment.js